import wait from '~/lib/wait.js'

export function longPoll(fetcher, handler) {
  const controller = new AbortController()
  let cancelled = false
  const cancel = () => {
    cancelled = true
    clearTimeout(timeout)
    controller.abort()
  }
  const connect = async (tries = 0) => {
    try {
      if (cancelled) return
      const res = await fetcher(controller.signal)
      if (res.status == 502) {
        // Status 502 is a connection timeout error,
        // may happen when the connection was pending for too long,
        // and the remote server or a proxy closed it
        // let's reconnect
        await wait(1000 * tries)
        await connect(tries + 1)
      } else if (res.status != 200) {
        // An error - let's show it
        console.error('longPoll error', res.statusText)
        // Reconnect in one second
        await wait(1000 * tries)
        await connect(tries + 1)
      } else {
        // Get and show the message
        handler(res)
        await connect(0)
      }
    }catch(error){
      if (error instanceof DOMException) return
      throw error
    }
  }
  let timeout = setTimeout(connect, 1)
  return cancel
}
